import React from "react"

//DBSALONI LINKS
import ServicesManagment from "../pages/servicesManagment"
import OerderManagement from "../pages/orderManagement"
import Dbinvoices from "../pages/dbInvoices"
import SettlementStatements from "../pages/dbInvoices/SettlementStatements"
import CancellationTracking from "../pages/CancellationTracking"
import Clients from '../pages/ClientManagement'
import TransactionHistory from '../pages/TransactionsHistory'
import DeleteLogs from "../pages/DeletionLogs"
import Refund from '../pages/Refund'
import { Navigate } from "react-router-dom"

// Profile
import AccountM from "../pages/accountManagement"

//Email
import EmailInbox from "../pages/Email/email-inbox"
import EmailRead from "../pages/Email/email-read"
import EmailBasicTemplte from "../pages/Email/email-basic-templte"
import EmailAlertTemplte from "../pages/Email/email-template-alert"
import EmailTemplateBilling from "../pages/Email/email-template-billing"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Dashboard
import Dashboard from "../pages/Dashboard/index"
import ServiceProvider from "../pages/service-providers"
import GeneralSetting  from "../pages/GeneralSttings"
// Maps
import MapsGoogle from "../pages/Maps/MapsGoogle"
import MapsVector from "../pages/Maps/MapsVector"
import MapsLeaflet from "../pages/Maps/MapsLeaflet"

//Pages
import PagesMaintenance from "../pages/Utility/pages-maintenance"
import PagesComingsoon from "../pages/Utility/pages-comingsoon"
import Pages404 from "../pages/Utility/pages-404"
import Pages500 from "../pages/Utility/pages-500"

const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/service-provider", component: <ServiceProvider /> },
  { path: "/general-settings", component: <GeneralSetting /> },
  { path: "/clinet-management", component: <Clients /> },
  { path: "/transactions_history", component: <TransactionHistory /> },
  { path: "/deletion_logs", component: <DeleteLogs /> },
  { path: "/refund_request", component: <Refund /> },
  { path: "/settlement-statements", component: <SettlementStatements /> },
  { path: "/cancellation-tracking", component: <CancellationTracking /> },

  
  { path: "/ServicesManagment", component: <ServicesManagment /> },
  { path: "/acount-management", component: <AccountM /> },
  { path: "/oerder-management", component: <OerderManagement /> },
  { path: "/dbinvoices", component: <Dbinvoices /> },
  //Email
  { path: "/email-inbox", component: <EmailInbox /> },
  { path: "/email-read", component: <EmailRead /> },
  { path: "/email-template-basic", component: <EmailBasicTemplte /> },
  { path: "/email-template-alert", component: <EmailAlertTemplte /> },
  { path: "/email-template-billing", component: <EmailTemplateBilling /> },
  // Maps
  { path: "/maps-google", component: <MapsGoogle /> },
  { path: "/maps-vector", component: <MapsVector /> },
  { path: "/maps-leaflet", component: <MapsLeaflet /> },
  { path: "/logout", component: <Logout /> },
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
]

const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/pages-maintenance", component: <PagesMaintenance /> },
  { path: "/pages-comingsoon", component: <PagesComingsoon /> },
  { path: "/pages-404", component: <Pages404 /> },
  { path: "/pages-500", component: <Pages500 /> },
]



export { authProtectedRoutes, publicRoutes }
